import { merge, mergeWith, isArray, find, each } from 'lodash'

const state = {
  extensions: [],
  languages: [],
  subscriptions: [],
  server: {
    offline: false,
    status: ''
  },
  view: 'tm-spinner',
  authentication: {
    show: false,
    status: false,
    user: '',
    message: ''
  }
}

const mutations = {
  RECEIVE_PRODUCTS_STATE (state, newstate) {
    mergeWith(state, newstate, (objValue, srcValue) => {
      if (isArray(objValue)) {
        return srcValue
      }
    })
  },
  SET_VIEW (state, view) {
    state.view = view
  },
  /* EXTENSIONS */
  MERGE_EXTENSIONS (state, extensions) {
    each(extensions, (extension) => {
      const found = find(state.extensions, ['name', extension.name])
      if (found) {
        const index = state.extensions.indexOf(found)
        state.extensions.$set(index, merge({}, found, extension))
      }
    })
  },
  /* LANGUAGES */
  MERGE_LANGUAGES (state, languages) {
    each(languages, (language) => {
      const found = find(state.languages, ['code', language.code])
      if (found) {
        const index = state.languages.indexOf(found)
        state.languages.$set(index, merge({}, found, language))
      }
    })
  },
  /* AUTHENTICATION */
  SHOW_AUTH (state) {
    state.authentication.show = true
  },
  HIDE_AUTH (state) {
    state.authentication.show = false
  },
  LOGIN_REQUEST (state) {
    state.authentication.message = 'Authenticating...'
  },
  LOGIN_SUCCESS (state, user) {
    state.authentication.status = true
    state.authentication.user = user
    state.authentication.message = ''
  },
  LOGIN_FAILURE (state, message) {
    state.authentication.status = false
    state.authentication.message = message
  },
  LOGOUT (state) {
    state.authentication.status = false
    state.authentication.user = ''
  }
}

export default {
  state,
  mutations
}



/** WEBPACK FOOTER **
 ** ./src/vuex/modules/products.js
 **/